import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { EncrDecrService } from "../../AuthGuard/EncrDecrService";
import { LosService } from "../../_LOS/services/los.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import * as XLSX from "xlsx";
import * as fs from "file-saver";
declare var $: any;
import * as FileSaver from "file-saver";
import { concatMap, tap } from "rxjs/operators";
import { Observable } from "rxjs";

import { LmsService } from "../../_Lms/services/lms.service";

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

@Component({
  selector: "app-ImportLoan",
  templateUrl: "./ImportLoan.component.html",
  styleUrls: ["./ImportLoan.component.scss"],
})
export class ImportLoanComponent implements OnInit {
  file: any;
  arrayBuffer: any;
  ImportLoanData: any;
  ImportShowLoanData: any = [];
  showSpinner: boolean = false;
  currentUser: any;
  displayedColumns: string[] = [];
  DataSource: MatTableDataSource<unknown>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    private LmsService: LmsService,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    private encdec: EncrDecrService,
    private losService: LosService
  ) {}

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  ngOnInit() {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.displayedColumns = [
      "Id",
      "LoanAcNo",
      "LoanAmount",
      "LoanTenure",
      "LoanEMIAmount",
      "EMIType",
      "LoanPurpose",
      "FirstEMIDate_YYYY_MM_DD",
      "Loan_Date_YYYY_MM_DD",
      "Interest_Amt", // Add these fields
      "Case_IRR",
      "Disbursement_IRR",
      "Effectice_IRR",
      "ROI",
      "View",
    ];
  }
  GetImportLoanData(event) {
    this.showSpinner = true;
    const target: HTMLInputElement = event.target as HTMLInputElement;
    this.file = target.files[0];
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.file);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i)
        arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      //console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      //this.ImportLoanData = XLSX.utils.sheet_to_json(worksheet);
      this.ImportLoanData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });

      this.showSpinner = false;
      if (this.ImportLoanData.length > 0) {
        this.ImportLoanData.forEach((x, index) => {
          var Requestdata = {
            Asset_Cost: 0,
            NetFinance_Amt: x.LoanAmount,
            Adv_Inst: 0,
            No_Of_Inst: x.LoanTenure,
            EMI_Type: x.EMIType,
            IRR_CalculateBy: "FLAT_EMI",
            EMI_Amount: x.LoanEMIAmount,
            cashflow: [],
            DaysInYear: this.currentUser.DaysInYear,
          };
          var customerJson = {
            LoanNo: x.LoanAcNo,
          };
          x.LoanExist = 0;
          this.LmsService.LMS_Get_ModifyBooking_List({
            LoginUserId: this.currentUser.userId,
            JSON: JSON.stringify(customerJson),
          }).subscribe((res: any) => {
            if (res.length > 0) {
              x.LoanExist = 1;
            }
          });
          this.LmsService.LMS_GetCalculateEMIIRR(Requestdata).subscribe(
            (res: any) => {
              const irrData = res[0];
              if (res.length > 0) {
                x.Interest_Amt = irrData.Interest_Amt;
                x.Case_IRR = irrData.Case_IRR;
                x.Disbursement_IRR = irrData.Disbursement_IRR;
                x.Effectice_IRR = irrData.Effectice_IRR;
                x.ROI = irrData.ROI;
                this.ImportShowLoanData.push(x);
                if (
                  this.ImportShowLoanData.length == this.ImportLoanData.length
                ) {
                  this.DataSource = new MatTableDataSource(
                    JSON.parse(JSON.stringify(this.ImportLoanData))
                  );
                  this.DataSource.paginator = this.paginator;
                  this.showSpinner = false;
                }
              }
            }
          );
        });

        //save FinalDataImport with irr
      }
    };
  }
  OnLoanConvert(row) {
    var Requestdata = {
      LoanAcNo: row.LoanAcNo,
      Application_InterestAmt: row.Interest_Amt,
      Application_Case_IRR: row.Case_IRR,
      Application_Disbursement_IRR: row.Disbursement_IRR,
      Application_LoanIRRate: row.ROI,
    };
    this.LmsService.ImportLoanData(Requestdata).subscribe((res: any) => {
      if (res.length > 0) {
        row.LoanExist = 1;
      }
    });
  }

  onImportLoanCustomerData() {
    this.LmsService.ImportLoanustomerData().subscribe((res: any) => {
      if (res[0].CODE >= 0) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
      }
      this.showSpinner = false;
    });
  }

  onImportDvData() {
    this.LmsService.IMPORTLOANDVDATA().subscribe((res: any) => {
      if (res[0].CODE >= 0) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
      }
    });
  }

  onImportPaymentDvData() {
    this.LmsService.IMPORTLOANDVPAYMENTDATA().subscribe((res: any) => {
      if (res[0].CODE >= 0) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
      }
    });
  }
}
